import { UPDATE_APP_STATE } from './actions'

const update = (state: any, payload: any) => ({
	...state,
	...payload
})

export default function reducer(state: any, { type, payload }: any) {
	switch (type) {
		case UPDATE_APP_STATE:
			return update(state, payload)
		default:
			return state
	}
}
